import { func } from "prop-types";

export const ADD_TRANSITION = "ADD_TRANSITION";
export const REMOVE_TRANSITION = "REMOVE_TRANSITION";
export const TOGGLE_MODELTESTSTATE = "TOGGLE_MODELTESTSTATE";
export const SHOW_ALERT = "SHOW_ALERT";
export const CART_ITEMS = "CART_ITEMS";
export const CLEAR_CART = "CLEAR_CART";
export const UPDATE_CART = "UPDATE_CART";
export const HIDE_ALERT = "HIDE_ALERT";
export const SESSION_ID = "SESSION_ID";
export const SHOW_CART_REFRESH_BANNER = "SHOW_CART_REFRESH_BANNER";
export const HIDE_CART_REFRESH_BANNER = "HIDE_CART_REFRESH_BANNER";
export const SET_SELECTED_STORE = "SET_SELECTED_STORE";
export const SET_DYNAMIC_BREADCRUMBS = "SET_DYNAMIC_BREADCRUMBS";
export const CHECKOUT_PROGRESS = "CHECKOUT_PROGRESS";
export const SET_PROGRESS_STEPS = "SET_PROGRESS_STEPS";
export const SHOW_REGION_MODAL = "SHOW_REGION_MODAL";
export const HIDE_TRIGGER = "HIDE_TRIGGER";
export function addTransition(name, path, title, fromRight, linktype, curtainBackgroundColor) {
  return {
    type: ADD_TRANSITION,
    name: name,
    path: path,
    title,
    fromRight,
    linktype,
    curtainBackgroundColor: curtainBackgroundColor
  };
}

export function removeTransition(name, path) {
  return { type: REMOVE_TRANSITION, name: name, path: path };
}
export function togglemodelTestState(payload) {
  return { type: TOGGLE_MODELTESTSTATE, payload };
}

export function showCartAlert(details) {
  return { type: SHOW_ALERT, details: details };
}
export function hideCartAlert() {
  return { type: HIDE_ALERT };
}
export function updateCartAction(payload) {
  return { type: UPDATE_CART, ...payload };
}
export function addToCartItems(ids) {
  return { type: CART_ITEMS, ids: ids };
}
export function removeCartItems(ids) {
  return { type: CART_ITEMS, ids: ids, action: "remove" };
}
export function clearCartItemsFromStorage() {
  return { type: CART_ITEMS, action: "clear" };
}
export function clearCartAction() {
  return { type: CLEAR_CART };
}
export function showCartRefreshBanner() {
  return { type: SHOW_CART_REFRESH_BANNER };
}
export function setSessionIdAction(sessionId) {
  return {
    type: SESSION_ID,
    sessionId: sessionId
  };
}
export function hideCartRefreshBanner() {
  return { type: HIDE_CART_REFRESH_BANNER };
}
export function hideTrigger(value) {
  return {
    type: HIDE_TRIGGER,
    value: value
  };
}

export function setStore(data) {
  return {
    type: SET_SELECTED_STORE,
    val: data
  };
}

export function setDynamicBreadcrumbList(list) {
  return {
    type: SET_DYNAMIC_BREADCRUMBS,
    val: list
  };
}

export function checkoutProgressAction(progressIndex) {
  return {
    type: CHECKOUT_PROGRESS,
    progress_index: progressIndex
  };
}
export function setProgressBarDataAction(progressBarSteps) {
  return {
    type: SET_PROGRESS_STEPS,
    progress_steps: progressBarSteps
  };
}

export function setShowRegionModal(value) {
  return {
    type: SHOW_REGION_MODAL,
    value: value
  };
}
